import React, { useCallback, useEffect, useMemo } from 'react';
import {
  matchPath,
  Route,
  Switch,
  useHistory,
  useLocation
} from 'react-router-dom';
import screenNavigator from '../../../services/ScreenNavigator';
import { FeatureRequest } from '../FeatureRequest.tsx';
import { HelpRoute } from '../HelpRoute.tsx';
import LogoutRoute from '../LogoutRoute.jsx';
import Billing from '../billing/Billing.jsx';
import { DevicesRoute } from '../devices/DevicesRoute.tsx';
import { SettingsRoute } from '../settings/SettingsRoute.tsx';
import { TripsRoute } from '../trips/TripsRoute.tsx';
import DeviceMapModalV2 from './DeviceMapModalV2';
import { useModalState } from '../../../hooks/modal/ModalStateProvider';

declare global {
  interface Window {
    cordova: any;
  }
}

interface ModalRouterProps { }

const routes = [
  { path: "/m/devices", component: DevicesRoute },
  { path: "/m/trips", component: TripsRoute },
  { path: "/m/billing", component: Billing },
  { path: "/m/help", component: HelpRoute },
  { path: "/m/feature-request", component: FeatureRequest },
  { path: "/m/settings", component: SettingsRoute },
  { path: "/m/logout", component: LogoutRoute },
];

// We use this so that we only show the modal if there's a path match
// (Previously we'd show if the path started with /m which was kinda buggy)
const isPathMatching = (path: string) => {
  return routes.some(route => matchPath(path, { path: route.path, exact: false }));
};

const ModalRouter: React.FC<ModalRouterProps> = () => {
  const location = useLocation();
  const history = useHistory();
  const { setOpen } = useModalState();

  const handleClose = useCallback(() => {
    screenNavigator.exitCurrentScreen(history);
  }, [history]);

  const isModalOpen = useMemo(() => isPathMatching(location.pathname), [location.pathname]);

  // Update modal state to indicate modal is actually open (useful elsewhere in the app)
  useEffect(() => {
    setOpen(isModalOpen);
  }, [isModalOpen, setOpen]);

  return (
    <DeviceMapModalV2 open={isModalOpen} onClose={handleClose} >
      <Switch>
        {routes.map(route => (
          <Route key={route.path} path={route.path} component={route.component} />
        ))}
      </Switch>
    </DeviceMapModalV2>
  );
};

export {
  ModalRouter
};

